export const buttonSocial = {
  global: {
    color: "#ffffff",
    hover: {
      color: "#ffffff"
    }
  },
  facebook: {
    backgroundColor: "#4267B2",
    hover: {
      backgroundColor: "#4267B2"
    }
  },
  twitter: {
    backgroundColor: "#1DA1F2",
    hover: {
      backgroundColor: "#1DA1F2"
    }
  },
  instagram: {
    backgroundColor: "#E0518F",
    hover: {
      backgroundColor: "#E0518F"
    }
  },
  youtube: {
    backgroundColor: "#FF0000",
    hover: {
      backgroundColor: "#FF0000"
    }
  },
  spotify: {
    backgroundColor: "#1DB954",
    hover: {
      backgroundColor: "#1DB954"
    }
  },
  soundcloud: {
    backgroundColor: "#FF5500",
    hover: {
      backgroundColor: "#FF5500"
    }
  },
  bandsintown: {
    backgroundColor: "#00B4B3",
    hover: {
      backgroundColor: "#00B4B3"
    }
  },
  pinterest: {
    backgroundColor: "#CA2028",
    hover: {
      backgroundColor: "#CA2028"
    }
  },
  apple: {
    backgroundColor: "#000000",
    hover: {
      backgroundColor: "#000000"
    }
  },
  google: {
    backgroundColor: "#ffffff",
    color: "#222222",
    hover: {
      backgroundColor: "#ffffff",
      color: "#222222"
    }
  }
};